"use client";

import { useLinkStatus } from "next/link";
import { Loader2, type LucideIcon } from "lucide-react";

export default function NavLinkContent({
  Icon,
  label,
}: {
  Icon: LucideIcon;
  label: string;
}) {
  const { pending } = useLinkStatus();
  return (
    <>
      {pending ? (
        <Loader2 className="size-4 shrink-0 animate-spin" />
      ) : (
        <Icon className="size-4 shrink-0" />
      )}
      {label}
    </>
  );
}
